import { Fork, Invoke } from '@swf/components/StarsWizard/Flow';
import type { FlowConfig } from '@swf/core/types/Wizard';

import RMFAddress from '../../components/RMFAddress/RMFAddress';
import RMFDOB from '../../components/RMFDOB/RMFDOB';
import RMFDepositLimit from '../../components/RMFDepositLimit/RMFDepositLimit';
import RMFLegalName from '../../components/RMFLegalName/RMFLegalName';
import RMFPhone from '../../components/RMFPhone/RMFPhone';
import RMFPlayerFundsProtection from '../../components/RMFPlayerFundsProtection/RMFPlayerFundsProtection';

import useRMFBaseSteps from './../useRMFBaseSteps';
import { Guard } from './../useRmfGuards';
import { Service } from './../useRmfServices';
import useRmfUKBaseSteps from './useRmfUKBaseSteps';

const useRmfUKDefaultFlow = (): FlowConfig => {
  const { jumpToFeatureStep, invokeLegalNameSave } = useRMFBaseSteps();
  const {
    forkVerification,
    invokeRetryEnableRealMoneyFlag,
    invokeDepositLimitSave,
    invokeEnableRealMoneyFlag,
    invokeUserDataSave,
    invokeMobilePhoneSave,
    forkEKYCFailCheck,
    retryMarker
  } = useRmfUKBaseSteps();

  const invokeRmfDobUpdate = new Invoke(Service.RmfDobUpdate, RMFPhone, RMFDOB);
  const forkDobCheck = new Fork(Guard.RmfDobEnabled, [RMFDOB, invokeRmfDobUpdate], [RMFPhone]);
  const invokeSignupDob = new Invoke(Service.SignupDobFetch, forkDobCheck);
  const invokeAddressSave = new Invoke(Service.RmfAddressSave, RMFDepositLimit, RMFAddress);

  return [
    invokeSignupDob,
    forkDobCheck,
    RMFPhone,
    invokeMobilePhoneSave,
    RMFLegalName,
    invokeLegalNameSave,
    RMFAddress,
    invokeAddressSave,
    RMFDepositLimit,
    invokeDepositLimitSave,
    RMFPlayerFundsProtection,
    invokeUserDataSave,
    invokeEnableRealMoneyFlag,
    retryMarker,
    forkEKYCFailCheck,
    invokeRetryEnableRealMoneyFlag,
    forkVerification,
    jumpToFeatureStep
  ];
};

export default useRmfUKDefaultFlow;
